export default __webpack_public_path__ + "static/media/logoWhite.dc9e0378.svg";